import { Link } from 'react-router';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { blogPosts } from '~/components/landing/BlogCarousel';

export default function BlogIndex() {
  return (
    <div className="h-screen overflow-y-auto bg-base-100">
      {/* Header */}
      <header className="py-6 px-8 lg:px-16 border-b border-base-200">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-primary">
            Gamgee Analytics
          </Link>
          <Link to="/" className="btn btn-ghost btn-sm gap-2">
            <FiArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Page Title */}
          <div className="mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">
              Resources & Insights
            </h1>
            <p className="text-lg opacity-70 max-w-2xl">
              Learn how leading e-commerce brands use data to drive growth, optimize conversions, and build sustainable businesses.
            </p>
          </div>

          {/* Blog Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="card bg-base-200 hover:shadow-lg transition-shadow group"
              >
                {/* Image */}
                {post.image ? (
                  <figure className="h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover"
                    />
                  </figure>
                ) : (
                  <figure className="h-48 bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                    <span className="text-5xl opacity-30">
                      {post.category === 'Strategy' && '📊'}
                      {post.category === 'Conversion' && '🛒'}
                      {post.category === 'Analytics' && '📈'}
                      {post.category === 'Operations' && '🚚'}
                    </span>
                  </figure>
                )}

                <div className="card-body">
                  {/* Category & Read Time */}
                  <div className="flex items-center gap-2 text-xs">
                    <span className="badge badge-primary badge-sm">{post.category}</span>
                    <span className="opacity-60">{post.readTime}</span>
                  </div>

                  {/* Title */}
                  <h2 className="card-title text-lg leading-tight group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>

                  {/* Excerpt */}
                  <p className="text-sm opacity-70 line-clamp-3">{post.excerpt}</p>

                  {/* Read More */}
                  <div className="flex items-center gap-1 text-sm text-primary mt-2 group-hover:gap-2 transition-all">
                    Read article
                    <FiArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-8 lg:px-16 bg-base-200 text-center">
        <p className="text-sm opacity-60">
          &copy; {new Date().getFullYear()} Gamgee Analytics. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
